import { Link } from "@remix-run/react";
import clsx from "clsx";

interface LogoProps {
    size?: "sm" | "md" | "lg" | "xxl";
    to?: string;
    variant?: "text" | "image";
}

const sizeClasses = {
    sm: "text-2xl",
    md: "text-3xl sm:text-4xl",
    lg: "text-5xl",
    xxl: "text-6xl",
};

// AIDEV-NOTE: Image size classes for logomark
const imageSizeClasses = {
    sm: "h-8 w-8",
    md: "h-12 w-12",
    lg: "h-32 w-32",
    xxl: "h-96 w-96",
};

export const LogoSmall: React.FC = () => (
    <Link
        to="/sessions"
        className="text-center text-3xl font-bold tracking-tight text-brand-forest-800 font-display"
    >
        Parts Companion
    </Link>
);

const Logo: React.FC<LogoProps> = ({
    size = "lg",
    to = "/",
    variant = "text",
}) => {
    if (variant === "image") {
        return (
            <div className="flex flex-col items-center justify-center">
                {/* AIDEV-NOTE: Logo owns its anchor so callers can override the destination
                    without nesting Links and triggering hydration mismatches. */}
                <Link to={to} className="flex items-center justify-center">
                    <img
                        src="/parts-companion-logomark.png"
                        alt="Parts Companion"
                        className={clsx(imageSizeClasses[size])}
                    />
                </Link>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center justify-center">
            <Link
                to={to}
                className={clsx(
                    "text-brand-forest-800 text-center font-bold mx-auto tracking-tight font-display",
                    sizeClasses[size],
                )}
                style={{ width: 200, lineHeight: 0.8 }}
            >
                Parts Companion
            </Link>
        </div>
    );
};

export const DisplayHeader: React.FC<{
    children: React.ReactNode;
    className?: string;
}> = (props) => (
    <div
        className={clsx(
            "text-4xl text-brand-forest-800 text-center font-bold font-display",
            props.className,
        )}
    >
        {props.children}
    </div>
);

export default Logo;
